import script from "./offer-line.vue?vue&type=script&setup=true&lang=js"
export * from "./offer-line.vue?vue&type=script&setup=true&lang=js"

import "./offer-line.vue?vue&type=style&index=0&id=3ecefee9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ecefee9"]])

export default __exports__